/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    SuperGroupRequest,
    SuperGroupRequestFromJSON,
    SuperGroupRequestToJSON,
    SuperGroupResponse,
    SuperGroupResponseFromJSON,
    SuperGroupResponseToJSON,
    SuperGroupsResponse,
    SuperGroupsResponseFromJSON,
    SuperGroupsResponseToJSON,
} from '../models';

export interface CreateSuperGroupRequest {
    superGroupRequest: SuperGroupRequest;
}

export interface DeleteSuperGroupRequest {
    id: string;
}

export interface ReadSuperGroupRequest {
    id: string;
}

export interface UpdateSuperGroupRequest {
    id: string;
    superGroupRequest: SuperGroupRequest;
}

/**
 * 
 */
export class SuperGroupsApi extends runtime.BaseAPI {

    /**
     * Create a new super group.
     */
    async createSuperGroupRaw(requestParameters: CreateSuperGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.superGroupRequest === null || requestParameters.superGroupRequest === undefined) {
            throw new runtime.RequiredError('superGroupRequest','Required parameter requestParameters.superGroupRequest was null or undefined when calling createSuperGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superGroups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SuperGroupRequestToJSON(requestParameters.superGroupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new super group.
     */
    async createSuperGroup(requestParameters: CreateSuperGroupRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createSuperGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete super group by ID.
     */
    async deleteSuperGroupRaw(requestParameters: DeleteSuperGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteSuperGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete super group by ID.
     */
    async deleteSuperGroup(requestParameters: DeleteSuperGroupRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteSuperGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Read super group by ID.
     */
    async readSuperGroupRaw(requestParameters: ReadSuperGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SuperGroupResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readSuperGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuperGroupResponseFromJSON(jsonValue));
    }

    /**
     * Read super group by ID.
     */
    async readSuperGroup(requestParameters: ReadSuperGroupRequest, initOverrides?: RequestInit): Promise<SuperGroupResponse> {
        const response = await this.readSuperGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read super groups.
     */
    async readSuperGroupsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SuperGroupsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuperGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Read super groups.
     */
    async readSuperGroups(initOverrides?: RequestInit): Promise<SuperGroupsResponse> {
        const response = await this.readSuperGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update super group by ID.
     */
    async updateSuperGroupRaw(requestParameters: UpdateSuperGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSuperGroup.');
        }

        if (requestParameters.superGroupRequest === null || requestParameters.superGroupRequest === undefined) {
            throw new runtime.RequiredError('superGroupRequest','Required parameter requestParameters.superGroupRequest was null or undefined when calling updateSuperGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/superGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SuperGroupRequestToJSON(requestParameters.superGroupRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update super group by ID.
     */
    async updateSuperGroup(requestParameters: UpdateSuperGroupRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateSuperGroupRaw(requestParameters, initOverrides);
    }

}
